import { Typography } from "antd";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import SkipLinks from "../SkipLinks";
import LoginLayoutHero from "./LoginLayoutHero";

type LoginLayoutProps = {
    title: string;
    className?: string;
};

const LoginLayout: FC<LoginLayoutProps> = ({ children, title, className }) => {
    const [t] = useTranslation();

    return (
        <div
            className={clsx(
                "h-dvh min-w-ant-screen-xs overflow-auto overscroll-none bg-ant-container bg-[length:20%] sm:bg-brand sm:bg-pattern",
                className,
            )}
        >
            <SkipLinks />
            <main
                role="main"
                id="main-content"
                className={clsx(
                    // START CONTAINER
                    "mx-auto w-full",
                    "sm:max-w-ant-screen-sm",
                    "md:max-w-ant-screen-md",
                    "lg:max-w-ant-screen-lg",
                    "xl:max-w-ant-screen-xl",
                    // END CONTAINER
                    "flex min-h-full flex-col items-center justify-center gap-ant-md xl:flex-row xl:items-start xl:justify-around",
                )}
            >
                <div
                    className={clsx(
                        "w-full max-w-[450px] p-ant-md xl:sticky xl:top-0 xl:min-h-[100cqh]",
                        "flex items-center justify-center",
                    )}
                    role="banner"
                >
                    <LoginLayoutHero className="" />
                </div>

                <section className="w-full shrink-0 justify-center sm:flex sm:w-ant-screen-xs-max sm:items-center sm:pb-ant xl:min-h-[100cqh] xl:py-ant xl:pr-ant ">
                    <div className="flex w-full flex-col gap-ant bg-ant-container p-ant-xl sm:rounded-ant-lg sm:border sm:border-ant-color">
                        {title ? (
                            <Typography.Title className="!m-0" level={1}>
                                {t(title)}
                            </Typography.Title>
                        ) : null}

                        <div className="flex flex-col">{children}</div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default LoginLayout;
